export function calculateReturnTime(reservation: any): string | null {
  const DEFAULT_TIME = "23:59:59";

  const isValidDate = (s: any): s is string => {
    if (typeof s !== "string") return false;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (!m) return false;
    const y = Number(m[1]), mon = Number(m[2]), d = Number(m[3]);
    if (mon < 1 || mon > 12) return false;
    const dt = new Date(Date.UTC(y, mon - 1, d));
    // Re-validate to catch invalids like 2025-02-31
    return dt.getUTCFullYear() === y && dt.getUTCMonth() === mon - 1 && dt.getUTCDate() === d;
  };

  const isValidTime = (s: any): s is string => {
    if (typeof s !== "string") return false;
    const m = /^(\d{2}):(\d{2}):(\d{2})$/.exec(s);
    if (!m) return false;
    const hh = Number(m[1]), mm = Number(m[2]), ss = Number(m[3]);
    return hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59 && ss >= 0 && ss <= 59;
  };

  const normalizeTime = (time: any | undefined | null, fallback?: string): string => {
    if (isValidTime(time)) return time as string;
    if (isValidTime(fallback)) return fallback as string;
    return DEFAULT_TIME;
  };

  const combine = (date: string, time: string) => `${date} ${time}`;

  const recurring = Array.isArray(reservation?.recurring) ? reservation.recurring : null;

  // If we have recurring entries, the top-level dates are ignored.
  if (recurring && recurring.length > 0) {
    const topLevelToTime = isValidTime(reservation?.to_time) ? (reservation.to_time as string) : undefined;

    let latest: string | null = null;

    for (const r of recurring) {
      const endDate = r?.end_date;

      // If end_date is missing or invalid in ANY recurring entry, it's endless → return null.
      if (!isValidDate(endDate)) {
        return null;
      }

      const timeForThis = normalizeTime(r?.end_time, topLevelToTime);
      const candidate = combine(endDate, timeForThis);

      if (latest === null || candidate > latest) {
        latest = candidate;
      }
    }

    return latest; // already "YYYY-MM-DD HH:MM:SS"
  }

  // No recurring → use top-level to / to_time
  const toDate = reservation?.to;
  if (!isValidDate(toDate)) {
    // Not specified, but safest is to fail closed with null if the top-level date is unusable.
    return null;
  }
  const finalTime = normalizeTime(reservation?.to_time);
  return combine(toDate, finalTime);
}
